export default __webpack_public_path__ + "static/media/DYL_logo_white.bdbce37c.svg";